import { Component, OnInit, ElementRef, ViewChild, Input, EventEmitter, Output, Self } from '@angular/core';
import { NgControl, Validators, AbstractControl } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'select-field-opportunity-type',
  templateUrl: './select-field-opportunity-type.component.html',
  styleUrls: ['./select-field-opportunity-type.component.scss']
})
export class SelectFieldOpportunityTypeComponent implements OnInit {

  @ViewChild('select', {static: true}) select: ElementRef;

  // inputs
  @Input() label: string = 'Opportunity Type';
  @Input() required: boolean = false;
  @Input() fieldError: string;
  @Input() isSubmitted: boolean = false;
  @Input() includeLabel: boolean = true;
  @Input() controlType: string;
  @Input() defaultValueLabel: string = 'Select Opportunity Type';

  @Output() ready: EventEmitter<any> = new EventEmitter();

  // options data
  options: any[];

  constructor(
    private _apiSvc: ApiService,
    private _utilsSvc: UtilitiesService,
    @Self() public ngCtrl: NgControl
  ) {
    ngCtrl.valueAccessor = this;
  }

  ngOnInit() {

    const ctrl = this.ngCtrl.control;
    this.select.nativeElement.value = '';

    this._apiSvc.get(`${this._apiSvc.endpoints.monolith}/api/OpportunityTypeCode`).subscribe((res: any) => {
      if (res?.Data) {
        this.options = res.Data;
        this.ready.emit();
        if (ctrl.value) {
          setTimeout(() => {
            this._checkCode(ctrl.value);
            this.writeValue(ctrl.value);
            this.ready.emit({opportunityResultCodes: res?.Data});
          }, 100);
        }
      }
    });

    this.ngCtrl.valueChanges.subscribe((value: any) => {
      this._checkCode(value).then(() => {
        setTimeout(() => {
          this.select.nativeElement.value = value;
        }, 100);
      });
    })
  }

  private _checkCode(opportunityTypeId: any): any {
    if(opportunityTypeId){
      opportunityTypeId = parseInt(opportunityTypeId);
    }
    return new Promise((resolve, _reject) => {

      const opportunityType: any = this._utilsSvc.getRecordById(this.options, opportunityTypeId);
      if (!opportunityType) {
        this._apiSvc.get(`${this._apiSvc.endpoints.monolith}/api/OpportunityTypeCode`, opportunityTypeId).subscribe((res: any) => {
          this.options.push(res);
          resolve(true);
        });
      } else {
        resolve(true);
      }
    });
  }

  onSelectChange(value: any) {
    
    if (value === 'null') {
      value = null;
    }

    this.onChange(value);
  }

  onChange(_value: any) {}

  onTouched() {}

  writeValue(value: any) {
    this.select.nativeElement.value = value;
  }

  registerOnChange(fn: (value: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(ctrl: AbstractControl) {
    return Validators.required(ctrl);
  }

}
